module.exports = __webpack_public_path__ + "images/application/templates/trial-683aeb4b.png";